<svelte:options runes={true} />

<script lang="ts">
  import type { KeyManager } from '@reactive';
  import { localeManager } from '@reactive';
  import type { MenuSelectEventDetail } from '@shoelace-style/shoelace/dist/components/menu/menu.component.js';
  import { Locale, LocaleId, StringId } from '@strings';
  import { reactTo } from '@utils';

  let { keyManager }: { keyManager: KeyManager } = $props();

  function handleSelect(event: CustomEvent<MenuSelectEventDetail>) {
    const value = event.detail.item.value;
    localeManager.localeId = value as LocaleId;
  }

  let checkedState = $derived.by(() => {
    const current = localeManager.localeId;
    const result: Record<string, boolean> = {};
    for (const id of Object.values(LocaleId)) {
      result[id] = id === current;
    }
    return result;
  });

  let itemName = $derived.by(() => {
    reactTo(localeManager.localeId);
    const result: Record<string, string> = {};
    for (const id of Object.values(LocaleId)) {
      const symbol = Locale.localizedString(StringId.LOCALE_SYMBOL, id);
      const name = Locale.localizedString(StringId.LOCALE_NAME, id);
      result[id] = `${symbol} ${name}`;
    }
    return result;
  });

  let itemNote = $derived.by(() => {
    reactTo(localeManager.localeId);
    const result: Record<string, string> = {};
    for (const id of Object.values(LocaleId)) {
      result[id] = keyManager.alt ? id : '';
    }
    return result;
  });
</script>

<div class="dropdown-selection">
  <sl-dropdown>
    <sl-button slot="trigger" caret size="small">
      {localeManager.localizedString(StringId.LOCALE_SYMBOL)}
      {localeManager.localizedString(StringId.LOCALE_NAME)}
    </sl-button>
    <sl-menu onsl-select={handleSelect} value={localeManager.localeId}>
      {#each Object.values(LocaleId) as localeId}
        <sl-menu-item checked={checkedState[localeId]} type="checkbox" value={localeId}>
          <div style="display: flex; flex-direction: row; align-items: center;">
            <div>{itemName[localeId]}</div>
            <div style="width: 10px;"></div>
            <div class="fl-note">{itemNote[localeId]}</div>
          </div>
        </sl-menu-item>
      {/each}
    </sl-menu>
  </sl-dropdown>
</div>
